import actionCreatorFactory from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api-base';
import { PriceType, RiskLevel, Side } from './markout.constant';
import {
  IBasicDashboardInfo,
  IBasicReportView,
  IMarkoutFilterOptionsData,
  IMarkoutReportData,
  IMarkoutSymbolRow,
} from './markout.interface';

const actionCreator = actionCreatorFactory('Markout');

export interface ILoadReportsParams {
  search?: string;
  status?: string;
  limit?: number;
  skip?: number;
}

export interface ILoadReportsResult {
  reports: IBasicReportView[];
  dashboard: IBasicDashboardInfo | null;
}

export interface ILoadReportDataParams {
  reportId?: number;
  jobId?: number;
  riskLevel?: RiskLevel[];
  servers?: string[];
  accountGroups?: string[];
  symbols?: string[];
  accounts?: string[];
  side?: Side;
  minNotional?: number;
  sort?: string[];
  limit?: number;
  skip?: number;
}

export interface ILoadAccountSymbolsParams {
  reportId?: number | string;
  jobId?: number | string;
  serverId: string;
  accountId: string;
}

export interface ILoadFilterOptionsParams {
  reportId?: number;
  jobId?: number;
}

export interface ILoadFormSymbolsParams {
  serverId: string;
}

export interface ICreateReportSettings {
  servers: string[];
  priceType: PriceType;
  reportPeriod: { interval: string; end: number };
  accounts: string[];
  accountGroups: string[];
  side?: Side;
  minNotional?: number;
  symbols: string[];
}

export interface ICreateReportParams {
  name: string;
  settings: ICreateReportSettings;
}

export interface ICreateReportResult {
  reportId: number;
}

export interface IStopReportParams {
  reportId: number | string;
}

export interface IRetryReportParams {
  reportId: number | string;
}

export const MarkoutAction = {
  loadReports: actionCreator.async<ILoadReportsParams, ILoadReportsResult, IApiErrorParams>('LOAD_REPORTS'),
  mergeReports: actionCreator<{ reports: IBasicReportView[] }>('MERGE_REPORTS'),
  dashboardLoaded: actionCreator<{ dashboard: IBasicDashboardInfo | null }>('DASHBOARD_LOADED'),
  loadReportData: actionCreator.async<ILoadReportDataParams, IMarkoutReportData, IApiErrorParams>('LOAD_REPORT_DATA'),
  clearReportData: actionCreator('CLEAR_REPORT_DATA'),
  loadAccountSymbols: actionCreator.async<ILoadAccountSymbolsParams, IMarkoutSymbolRow[], IApiErrorParams>('LOAD_ACCOUNT_SYMBOLS'),
  clearAccountSymbols: actionCreator('CLEAR_ACCOUNT_SYMBOLS'),
  loadFilterOptions: actionCreator.async<ILoadFilterOptionsParams, IMarkoutFilterOptionsData, IApiErrorParams>('LOAD_FILTER_OPTIONS'),
  loadFormSymbols: actionCreator.async<ILoadFormSymbolsParams, { symbols: string[] }, IApiErrorParams>('LOAD_FORM_SYMBOLS'),
  createReport: actionCreator.async<ICreateReportParams, ICreateReportResult, IApiErrorParams>('CREATE_REPORT'),
  stopReport: actionCreator.async<IStopReportParams, void, IApiErrorParams>('STOP_REPORT'),
  retryReport: actionCreator.async<IRetryReportParams, void, IApiErrorParams>('RETRY_REPORT'),
  startReportsPolling: actionCreator('START_REPORTS_POLLING'),
  stopReportsPolling: actionCreator('STOP_REPORTS_POLLING'),
  reloadReportList: actionCreator('RELOAD_REPORT_LIST'),
  reloadReportData: actionCreator('RELOAD_REPORT_DATA'),
  destroy: actionCreator('DESTROY'),
};
